<!-- header config -->
<div *ngIf="expansionStyle == 'session_expired_header'">
    <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Header Label</div></div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="headerLabel">Label</label></div>
                <input
                        id="headerLabel"
                        cclFormInput
                        type="text"
                        class="c-form-group__input c-input--required"
                        [(ngModel)]="sessionExpiredHeaderConfig.label"
                        maxlength="100"
                />
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="headerLabelColor">Label Color</label>
                </div>
                <div
                        class="input-group"
                        [(colorPicker)]="sessionExpiredHeaderConfig.label_color"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'left'"
                >
                    <input
                            id="headerLabelColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="sessionExpiredHeaderConfig.label_color"
                            class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': sessionExpiredHeaderConfig.label_color }"
                        >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="headerBackgroundColor">Background Color</label>
                </div>
                <div
                        class="input-group"
                        [(colorPicker)]="sessionExpiredHeaderConfig.background"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'left'"
                >
                    <input
                            id="headerBackgroundColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="sessionExpiredHeaderConfig.background"
                            class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': sessionExpiredHeaderConfig.background }"
                        >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="fontStyle">Font Style</label></div>
                <ccl-simple-select
                        formId="fontStyle"
                        [listOfItems]="sharedService.fontStyles"
                        (valueChange)="sessionExpiredHeaderConfig.fontStyle = $event.value"
                        [value]="sessionExpiredHeaderConfig.fontStyle"
                        [bindValue]="'id'"
                        [bindLabel]="'label'"
                        [isClearable]="false"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>
</div>

<!-- body config -->
<div *ngIf="expansionStyle == 'session_expired_body'">
    <div class="row">
        <div class="col-sm-12">
            <div class="c-form-group">
                <label class="label-lg">Body Content</label>
                <ng-container>
                    <simple-tiny
                            [model]="sessionExpiredBodyConfig.text"
                            (onEditorKeyup)="sessionExpiredBodyConfig.text = $event"
                            id="2"
                            [extendedValidElements]="sharedService.extendedValidElements"
                    ></simple-tiny>
                </ng-container>
                <div class="clearfix"></div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
            <div class="clearfix"></div>
        </div>
    </div>
</div>

<!-- button config -->
<div *ngIf="expansionStyle == 'session_expired_button'">
    <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Primary</div></div>
    </div>

    <div class="row">
        <div class="col-sm-12" >
            <ccl-checkbox
                    buttonStyle="c-checkbox"
                    (clickEvent)="sessionExpiredButtonConfig.primary.isPrimaryEnabled = !sessionExpiredButtonConfig.primary.isPrimaryEnabled"
                    [id]="'isPrimaryEnabled'"
                    [value]="sessionExpiredButtonConfig.primary.isPrimaryEnabled"
            >Enable Primary Button</ccl-checkbox>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>

    <div class="row" *ngIf="sessionExpiredButtonConfig.primary.isPrimaryEnabled">
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="buttonLabel">Label</label></div>
                <input
                        id="buttonLabel"
                        cclFormInput
                        type="text"
                        class="c-form-group__input c-input--required"
                        [(ngModel)]="sessionExpiredButtonConfig.primary.label"
                        maxlength="20"
                />
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="sessionExpiredButtonConfig.primary.isPrimaryEnabled">
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="buttonBackground">Background</label></div>
                <div
                        class="input-group"
                        [(colorPicker)]="sessionExpiredButtonConfig.primary.background"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                >
                    <input
                            id="buttonBackground"
                            cclFormInput
                            type="text"
                            [(ngModel)]="sessionExpiredButtonConfig.primary.background"
                            class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': sessionExpiredButtonConfig.primary.background }"
                        >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="buttonFontColor">Font Color</label></div>
                <div
                        class="input-group"
                        [(colorPicker)]="sessionExpiredButtonConfig.primary.color"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'left'"
                >
                    <input
                            id="buttonFontColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="sessionExpiredButtonConfig.primary.color"
                            class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': sessionExpiredButtonConfig.primary.color }"
                        >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>
</div>
